import { render, staticRenderFns } from "./HomeWellbeingStudio.vue?vue&type=template&id=f1f9831a"
import script from "./HomeWellbeingStudio.vue?vue&type=script&lang=js"
export * from "./HomeWellbeingStudio.vue?vue&type=script&lang=js"
import style0 from "./HomeWellbeingStudio.vue?vue&type=style&index=0&id=f1f9831a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports